import { List } from "@mui/material";
import { Add } from "@mui/icons-material";
import { ReactElement } from "react";
import IdeaPageEntry from "./IdeaPageEntry";
import { useSession } from "@toolpad/core";
import Session from "../../../../appfw/authentication/Session";
import { useLocation } from "react-router-dom";
import { W2d2dNavigation } from "../../../W2d2dNavigation.tsx";
import { useIdeasControl } from "../../hooks/useIdeasControl";

import AppFwFab from "../../../../appfw/ui/buttons/AppFwFab.tsx";

export default function IdeasPage() {

    const location = useLocation()
    const session = useSession<Session>()
    const { ideas } = useIdeasControl()

    let ideasEl: ReactElement[] = []
    let user = session?.user
    if (user && ideas) {
        ideas.forEach((idea) => {
            ideasEl.push(<IdeaPageEntry user={user} idea={idea} key={idea.id} />)
        })
    }

    let fabEl
    if (ideas) {
        fabEl = (
            W2d2dNavigation.ideas.add.linkEl(
                location,
                <AppFwFab aria-label="Neue Idee">
                    <Add />
                </AppFwFab>
            )
        )
    }

    return (
        <>
            <List sx={{ width: '100%' }}>
                {ideasEl}
            </List>
            {fabEl}
        </>
    )
}
